import { NavLink } from 'react-router-dom'
import { useAppSelector } from '@store/hooks'
import { UserRole } from '../../../types/auth.types'
import './Sidebar.scss'

interface MenuItem {
  path: string
  icon: string
  label: string
  roles?: UserRole[]
}

const menuItems: MenuItem[] = [
  { path: '/dashboard', icon: 'bi-speedometer2', label: 'Dashboard' },
  { path: '/search', icon: 'bi-search', label: 'Entity Search' },
  { path: '/hits', icon: 'bi-flag', label: 'Hit Review' },
  { path: '/data-pool', icon: 'bi-database', label: 'Data Pool' },
  { path: '/jobs', icon: 'bi-hourglass-split', label: 'Jobs & Reports' },
  { path: '/analytics', icon: 'bi-graph-up', label: 'Analytics' },
  { path: '/audit-log', icon: 'bi-shield-lock', label: 'Audit Log' },
  {
    path: '/admin',
    icon: 'bi-gear',
    label: 'Administration',
    roles: [UserRole.ADMIN],
  },
]

export const Sidebar = () => {
  const { user } = useAppSelector(state => state.auth)

  const canAccessMenuItem = (item: MenuItem): boolean => {
    if (!item.roles) return true
    return item.roles.includes(user?.role as UserRole)
  }

  return (
    <aside className="crif-sidebar">
      <nav className="crif-sidebar-nav">
        {menuItems.map(
          item =>
            canAccessMenuItem(item) && (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `crif-sidebar-item ${isActive ? 'active' : ''}`
                }
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </NavLink>
            )
        )}
      </nav>
    </aside>
  )
}

export default Sidebar
